import { supabaseBrowser } from '@/lib/supabase-browser';

export const supabase = supabaseBrowser;
